<script>
  export let size = 52;
  export let label = "Excel file icon";
</script>

<svg
  width={size}
  height={size}
  viewBox="12 4 30 38"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  role="img"
  aria-label={label}
>
  <defs>
    <filter
      id="shadow"
      x="8"
      y="4"
      width="36"
      height="42"
      filterUnits="userSpaceOnUse"
    >
      <feDropShadow
        dx="0"
        dy="1"
        stdDeviation="0.6"
        flood-color="#000000"
        flood-opacity="0.14"
      />
    </filter>
    <linearGradient
      id="paper"
      x1="18"
      y1="8"
      x2="34"
      y2="40"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#FFFFFF" />
      <stop offset="1" stop-color="#F6F6F6" />
    </linearGradient>
    <linearGradient
      id="fold"
      x1="33"
      y1="8"
      x2="40"
      y2="15"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#FAFAFA" />
      <stop offset="1" stop-color="#EDEDED" />
    </linearGradient>
    <linearGradient
      id="excelGreen"
      x1="14"
      y1="24"
      x2="26"
      y2="36"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#2FB463" />
      <stop offset="1" stop-color="#1E8E4B" />
    </linearGradient>
  </defs>

  <g filter="url(#shadow)">
    <path
      d="M19 8.75C19 7.7835 19.7835 7 20.75 7H31.9948C32.4546 7 32.8956 7.18268 33.2207 7.50776L39.4922 13.7793C39.8173 14.1044 40 14.5454 40 15.0052V36.25C40 37.2165 39.2165 38 38.25 38H20.75C19.7835 38 19 37.2165 19 36.25V8.75Z"
      fill="url(#paper)"
    />
    <path
      d="M19 8.75C19 7.7835 19.7835 7 20.75 7H31.9948C32.4546 7 32.8956 7.18268 33.2207 7.50776L39.4922 13.7793C39.8173 14.1044 40 14.5454 40 15.0052V36.25C40 37.2165 39.2165 38 38.25 38H20.75C19.7835 38 19 37.2165 19 36.25V8.75Z"
      stroke="#9E9E9E"
      stroke-width="1.15"
    />
    <path
      d="M32 7.6V13.2C32 14.1941 32.8059 15 33.8 15H39.4"
      fill="url(#fold)"
    />
    <path
      d="M32 7.6V13.2C32 14.1941 32.8059 15 33.8 15H39.4"
      stroke="#9E9E9E"
      stroke-width="1.15"
      stroke-linejoin="round"
    />
  </g>

  <g>
    <rect
      x="15"
      y="22.75"
      width="12.8"
      height="13.8"
      rx="1.7"
      fill="url(#excelGreen)"
    />
    <rect
      x="15"
      y="22.75"
      width="12.8"
      height="13.8"
      rx="1.7"
      stroke="#187A3F"
      stroke-width="0.55"
    />
    <path
      d="M19.15 26.25L21.55 29.6L19.05 33.05H20.95L22.52 30.72L24.08 33.05H26.05L23.5 29.48L25.84 26.25H23.98L22.56 28.38L21.15 26.25H19.15Z"
      fill="white"
    />
  </g>
</svg>
